'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var ADD_DOC_EVENT = exports.ADD_DOC_EVENT = 'REACT_STORYBOOK/doc/add';